import React from "react";
import Canonical from "../components/Canonical";

const Disclaimer = () => {
  const canonicalUrl = "https://homesdekho.com/disclaimer";
  const hrfLangTag = "https://homesdekho.com/disclaimer";
  const title = "Disclaimer | Information Accuracy at HomesDekho";
  const description =
    "Read HomesDekho's disclaimer regarding content accuracy, liability, and third-party information provided on our website and real estate listings.";
  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={title}
        hrfLang={hrfLangTag}
        description={description}
      />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="privacy-txt mt-3">Disclaimer</h1>
          </div>
          <div className="col-md-12">
            <p className="privacy-para">
              Homes Dekho is solely a marketing partner for developers and
              provides online marketing services in that regard. It does not in
              any way facilitate sales between developers and visitors who may
              become actual consumers of the developer's products. All the
              information displayed on this website is provided on an "as is"
              basis and is shared directly by the respective developers. Homes
              Dekho has no role in creating such information. The visual
              representation of properties is based on artistic impressions and
              may not exactly match the final property details. Consumers are
              strongly advised to visit the property site and verify the
              offerings themselves. Visuals of interiors, furnishings, white
              goods, surroundings, and roads are only illustrative and may not
              necessarily be included with the property. Homes Dekho does not
              provide any warranty, express or implied, on the information shown
              on this website.
            </p>
            <p className="privacy-para">
              While every effort is made to present accurate information that
              reflects the market scenario, the details displayed are sourced
              from developers, and due to the dynamic nature of the real estate
              sector, they may change by the time they reach the end consumer.
              Homes Dekho does not accept any liability for the accuracy or
              completeness of the information or for decisions made based on it.
              Further, the presence of a project or developer on our website
              does not guarantee registration or compliance under the Real
              Estate (Regulation and Development) Act, 2016 (“RERA”).
            </p>
            <p className="privacy-para">
              The information provided on our website is only to assist users in
              their property search on a best-effort basis. As Homes Dekho
              cannot control how this information is ultimately used by the
              consumer, it disclaims all warranties of merchantability and
              fitness for a particular purpose. Visitors acknowledge that they
              are accessing the website at their own discretion and judgment.
              Any transaction undertaken by the Visitor based on the information
              provided is entirely at their own risk, and Homes Dekho does not
              undertake liability for the same.
            </p>
            <p className="privacy-para">
              Since most content is sourced from third-party developers, Homes
              Dekho is not responsible for any errors, omissions, or
              inaccuracies in the data provided. If such information turns out
              to be incomplete, false, or misleading, Homes Dekho cannot be held
              accountable, nor does this constitute an unfair practice under
              RERA.
            </p>
            <p className="privacy-para">
              Although we adopt best practices and maintain strict cybersecurity
              measures, we do not guarantee that the website will always
              function without interruptions, errors, or security risks such as
              viruses or other harmful components. By using the Homes Dekho
              website, the Visitor acknowledges and accepts all associated
              risks. Homes Dekho, including its directors, employees, and
              representatives, shall not be held liable for: (a) any
              inaccuracies, omissions, or errors in the information provided;
              (b) any actions, costs, or losses incurred by reliance on such
              information; or (c) any defaults, delays, or failures on the part
              of developers, including delivery of services, amenities, or
              completion of projects as advertised.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Disclaimer;
